<template>
  <div :class="['op--modal-container', {hide: !show}]">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="cancellation small-margin-v-s">
          <i class="fas fa-times-circle close-icon fa-2x" @click="close" v-show="!loadingFee && !done && !cancelling"></i>
          <div class="loaderx" v-show="loadingFee"><i class="fa fa-2x fa-circle-notch fa-spin"></i></div>
          <div v-show="!loadingFee">
            <div v-show="!cancelling && !done">
              <div class="credit-box" v-if="showRefundCredit && refundToggle">
                <p>{{ $t('rsvpEdit.convertCredit') }}</p>
                <p>
                  {{ $t('rsvpEdit.convertDesc1') }}
                  <b>${{ total }}</b> 
                  {{ $t('rsvpEdit.convertDesc2') }}
                  {{ $t('rsvpEdit.convertDesc3') }}
                </p>
                <p>{{ $t('rsvpEdit.confirmConvert') }}</p>
                <a class="op-btn btn-lg btn-block btn-danger" href="javascript:;" @click="cancel(rsvpId)">{{ $t('rsvpEdit.yes') }}</a>
                <a class="cancel-btn" href="javascript:;" @click="declineCredit">{{ $t('rsvpEdit.no') }}</a>
              </div>
              <div class="non-credit-box" v-else>
                <div class="title">{{ $t('rsvpEdit.confirmCancel') }}</div>
                <div class="cancel-reason">
                  <div class="label">{{ $t('rsvpEdit.whyCancel') }}</div>
                  <select v-model="cancellation.selectedReason">
                    <option value="-1">{{ $t('rsvpEdit.chooseOne') }}</option>
                    <option :value="index" v-for="(value, index) in cancellation.reasons">{{ value }}</option> 
                  </select>
                  <textarea v-show="cancellation.selectedReason === 11" v-model="cancellation.customReason"></textarea>
                </div>
                <div class="message lyft-error"  v-if="isLyft">{{ $t('rsvpEdit.cxlFeeWillApply') }}</div>
                <div class="message margin-b-m" v-html="message" v-if="!refundAsCredits"></div>
                <div class="error-message" v-show="cancellation.showError">{{ $t('rsvpEdit.provideReason') }}</div>
                <a class="op-btn btn-lg btn-block btn-danger" href="javascript:;" @click="cancel(rsvpId)">{{ $t('rsvpEdit.yesCancel') }}</a>
                <a class="cancel-btn" href="javascript:;" @click="close">{{ $t('rsvpEdit.noCancel') }}</a>
              </div>
            </div>

            <div class="loaderx" v-show="cancelling">
              <i class="fa fa-2x fa-circle-notch fa-spin"></i>
              <div class="margin-t-xs">{{ $t('rsvpEdit.cancelRsvp') }}</div>
            </div>

            <div class="loaderx" v-show="done">
              <div v-show="success">
                <div class="success-box margin-b-m">
                  <i class="fa fa-3x fa-check-circle"></i>
                  <div class="margin-t-xs" v-if="refundAsCredits">
                    {{ $t('rsvpEdit.rsvp') }}
                    {{ queue.success.length ? queue.success.join(', ') : rsvpId }}
                    {{ $t('rsvpEdit.creditSuccess') }}
                  </div>
                  <div class="margin-t-xs" v-else>{{ $t('rsvpEdit.cancelSuccess') }}</div>
                </div>

                <div v-if="rsvps.length" class="margin-b-s">
                  <div class="margin-b-s" style="line-height: 1.4">
                    You have other active reservations in your account.
                    <br/>
                    <span v-if="refundAsCredits">Would you like to convert any of these reservations into ride credits?</span>
                    <span v-else>Would you like to cancel any of these reservations?</span>
                  </div>
                  <div class="rsvp-box margin-b-m">
                    <label class="rsvp-item" v-for="(rsvp, i) in rsvps" :key="i">
                      <input type="checkbox" id="asd" :value="rsvp.id" v-model="selected" />
                      <div class="rsvp-info">
                        <b>
                          Res {{rsvp.id}}
                          <b class="margin-l-s" v-if="!refundAsCredits">(Cancel Fee: ${{rsvp.cancelFee}})</b>
                          <span>{{rsvp.pickupDate}}</span>
                        </b>
                        <div>{{rsvp.pickup}} &nbsp;>&nbsp; {{rsvp.dropoff}}</div>
                      </div>
                    </label>
                  </div>
                  <a :class="['op-btn btn-lg btn-block btn-danger margin-b-m', {disabled:!selected.length}]" href="javascript:;" @click="initRsvpCxl">
                    <span v-if="refundAsCredits">Yes, convert my selected reservations</span>
                    <span v-else>Yes, cancel my selected reservations</span>
                  </a>
                  <a class="cancel-btn" href="javascript:;" @click="closeEdit">
                    No, keep my other reservations
                  </a>
                </div>

                <a class="cancel-btn" href="javascript:;" @click="closeEdit" v-else>{{ $t('rsvpEdit.ok') }}</a>
              </div>

              <div v-show="!success">
                <i class="fa fa-3x fa-times-circle"></i>
                <div class="margin-t-xs">{{ $t('rsvpEdit.oops') }}</div>
                <a class="cancel-btn" href="javascript:;" @click="close">{{ $t('rsvpEdit.tryAgain') }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
export default {
  name: 'cancel-reservation',
  data () {
    return {
      loadingFee: false,
      message: '',
      cancelling: false,
      done: false,
      success: false,
      cancellation: {
        reasons: [
          this.$t('rsvpEdit.reason1'),
          this.$t('rsvpEdit.reason2'),
          this.$t('rsvpEdit.reason3'),
          this.$t('rsvpEdit.reason4'),
          this.$t('rsvpEdit.reason5'),
          this.$t('rsvpEdit.reason6'),
          this.$t('rsvpEdit.reason7'),
          this.$t('rsvpEdit.reason8'),
          this.$t('rsvpEdit.reason9'),
          this.$t('rsvpEdit.reason10'),
          this.$t('rsvpEdit.reason11'),
          this.$t('rsvpEdit.reason12')
        ],
        selectedReason: -1,
        customReason: '',
        showError: false
      },
      showRefundCredit: true,
      refundAsCredits: true,
      total: 0,
      refundToggle: false,
      rsvps: [],
      selected: [],
      queue: {
        success: [],
        fail: [],
        getFee: []
      },
      isLyft: false
    }
  },
  computed: {
    cancellationStore () { return this.$store.state.rsvpEdit.cancellation },
    show () { return this.cancellationStore.show },
    rsvpTrackStore () { return this.$store.state.rsvpTrack },
    rsvpId () {
      if (this.$route.name === 'RsvpTrack') return this.rsvpTrackStore.rsvp.id
      return this.$store.state.rsvpEdit.originalRsvp.id
    }
  },
  methods: {
    close () {
      this.showRefundCredit = true
      this.refundAsCredits = true
      this.$store.commit('rsvpEdit/hideCancellation')
    },
    cancel (id) {
      let self = this
      let selectedReason = self.cancellation.selectedReason
      let cancelReason = self.refundAsCredits ? '' : self.cancellation.reasons[selectedReason]
      let customReason = self.cancellation.customReason
      if (selectedReason < 0 && !self.refundAsCredits) {
        self.cancellation.showError = true
        return
      }
      if (selectedReason === 11 && customReason === '') {
        self.cancellation.showError = true
        return
      }
      if (selectedReason === 11) {
        cancelReason = customReason
      }
      self.cancellation.showError = false
      self.cancelling = true
      self.done = false

      let rsvp = self.$store.state.rsvpEdit.originalRsvp
      if (self.cancellationStore.type === 'track') rsvp = self.rsvpTrackStore.rsvp
      let cust = rsvp.consumer
      self.$sdk.post(self, `/reservations/${id}/${cust.firstName}/${cust.lastName}/cancel`, {
        reason: cancelReason,
        refundAsCredits: self.refundAsCredits
      }, r => {
        if (r.error) {
          self.cancelling = false
          self.done = true
          self.success = false

          if (self.selected.length) {
            self.queue.fail.push(id)
            self.selected.shift()
            if (self.selected.length) self.cancel(self.selected[0])
            else self.success = true
          }
          return
        }

        if (window.opoliCNS) {
          let segment = {
            key: 'HomePage_Cancel Ride',
            'Reservation Number': id,
            'First Name': cust.firstName,
            'Last name': cust.lastName
          }
          window.opoliCNS('events', {
            key: 'HomePage_Cancel Ride',
            segment: segment,
            url: null,
            widgetEvent: true
          })
        }

        if (self.selected.length) {
          self.queue.success.push(id)
          self.selected.shift()
          if (self.selected.length) self.cancel(self.selected[0])
          else {
            self.cancelling = false
            self.done = true
            self.success = true
          }
        } else {
          self.checkUpcoming()
        }
      })
    },
    closeEdit () {
      // let loc = window.location.href
      // let index = loc.indexOf('#')
      // window.location = loc.substring(0, index) + '#'

      // this.$root.$emit('close')
      this.$store.commit('reservation/setOptinData', {
        leg: 'leg1',
        fields: {enabled: false}
      })
      this.close()
      // this.$root.$router.push('search-edit')
      this.$root.$router.push('search')
      document.body.classList.remove('widget-full')
    },
    declineCredit () {
      this.showRefundCredit = false
      this.refundAsCredits = false
    },
    checkUpcoming () {
      let self = this

      let rsvp = self.$store.state.rsvpEdit.originalRsvp
      if (self.cancellationStore.type === 'track') rsvp = self.rsvpTrackStore.rsvp
      let cust = rsvp.consumer
      self.$sdk.get(self, `/reservations/${rsvp.id}/${cust.firstName}/${cust.lastName}/upcoming`, {}, r => {
        if (!r.error) {
          r.list.forEach(rsvp => {
            let pickup = rsvp.pickup.split(',')
            let dropoff = rsvp.dropoff.split(',')
            if (rsvp.dispatchStatus === 'upcoming') {
              self.rsvps.push({
                id: rsvp.ID,
                pickupDate: moment(rsvp.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
                pickupDateUnix: moment(rsvp.pickupDate, 'YYYY-MM-DD HH:mm').format('X'),
                pickup: pickup[0],
                dropoff: dropoff[0]
              })
            }
          })
          self.rsvps.sort((a, b) => {
            return a.pickupDateUnix - b.pickupDateUnix
          })
        }
        if (self.rsvps.length) {
          this.queue.getFee = [...this.rsvps]
          this.getFee(this.queue.getFee[0].id)
          return
        }
        self.cancelling = false
        self.done = true
        self.success = true
      })
    },
    initRsvpCxl () {
      if (!this.selected.length) return
      // this.loadingFee = true
      this.rsvps = []
      this.queue = {
        success: [],
        fail: []
      }
      // this.getFee(this.selected[0])
      this.cancel(this.selected[0])
    },
    getFee (id) {
      let self = this
      let rsvp = self.$store.state.rsvpEdit.originalRsvp
      if (self.cancellationStore.type === 'track') rsvp = self.rsvpTrackStore.rsvp
      let cust = rsvp.consumer
      self.$sdk.get(self, `/reservations/${id}/${cust.firstName}/${cust.lastName}/cancel`, {}, r => {
        let i = self.rsvps.findIndex(x => x.id === id)
        if (i > -1) {
          self.rsvps[i].cancelFee = r.error ? 0 : r.amount
        }
        self.queue.getFee.shift()
        if (self.queue.getFee.length) self.getFee(self.queue.getFee[0].id)
        else {
          self.cancelling = false
          self.done = true
          self.success = true
        }
      })
    }
  },
  watch: {
    show (value) {
      if (!value) return
      let self = this
      let rsvp = self.$store.state.rsvpEdit.originalRsvp
      if (self.cancellationStore.type === 'track') rsvp = self.rsvpTrackStore.rsvp
      let cust = rsvp.consumer
      self.cancelling = false
      self.done = false
      self.success = false
      self.loadingFee = true
      self.$sdk.get(self, '/reservations/' + rsvp.id + '/' + cust.firstName + '/' + cust.lastName + '/cancel', {}, r => {
        self.loadingFee = false
        self.message = self.$t('rsvpEdit.cancelRsvp2')
        if (r.error) { return }
        // self.total = parseFloat(r.rsvpData.breakdown.total + r.rsvpData.gasFee).toFixed(2)
        if (r.lyft) {
          self.isLyft = true
          self.showRefundCredit = false
          self.refundToggle = false
          self.refundAsCredits = false
          return
        }
        self.total = parseFloat(r.meta.trxAmount.toFixed(2))
        let amount = parseFloat(r.amount)
        if (amount > 0) {
          self.message = self.$t('rsvpEdit.chargeAmount', {amount: amount.toFixed(2)})
        }
      })
    }
  },
  mounted () {
    this.refundToggle = this.$settings.get('RideCreditOffer') === 1
  }
}
</script>

<style lang="scss" scoped>
.cancellation {
  background-color: #fff;
  max-width: 450px;
  margin: 10px auto !important;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  position: relative;

  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 15px;
  }
}

.loaderx {
  text-align: center;
  color: #777;

  & .fa-check-circle { color: #26D97A; }
  & .fa-times-circle { color: #F20D0D; }
}

.cxl{
  position: relative;
}

.message { text-align: center; }

.cancel-btn {
  display: block;
  text-align: center;
  margin-top: 10px;
  color: #cb8112;

  &.disabled{
    cursor: not-allowed!important;
  }
}

.cancel-reason {
  margin-bottom: 20px;
  & .label {
    margin-bottom: 10px;
  }

  & select {
    display: block;
    outline: none;
    box-sizing: border-box;
    border: 0;
    width: 100%;
    border-radius: 3px;
    border: 1px solid rgba(0,0,0,0.15);
    transition: all 250ms;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  & textarea {
    margin-top: 10px;
    display: block;
    outline: none;
    box-sizing: border-box;
    padding: 10px;
    border: 0;
    width: 100%;
    border-radius: 3px;
    border: 1px solid rgba(0,0,0,0.15);
    transition: all 250ms;
    line-height: inherit;
    resize: none;
    height: 100px;
  }
}
.error-message {
  margin-bottom: 20px;
  color: red;
  font-size: 14px;
  text-align: center;
}

.close-icon{
  position: absolute;
  z-index: 2;
  top: -10px;
  right: -10px;
  color: #e53b3b;
  border-radius: 100%;
  background: #fff;
  cursor: pointer;
}

.success-box{
  padding: 10px 5px;
  background: #edffed;
  border: 1px solid #53b34f;
  border-radius: 4px;
}

.rsvp-box{
  border: 1px solid #ddd;
  border-radius: 4px;
  max-height: 250px;
  overflow: auto;
}
.rsvp-item{
  padding: 7px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ddd;
  cursor: pointer;

  &:hover{
    background: #f6f6f6;
  }
  input{
    padding: 0;
    margin: 0;
  }
}
.rsvp-info{
  width: 100%;
  padding-left: 10px;
  line-height: 1;
  font-size: 14px;
  text-align: left;

  b{
    margin-bottom: 2px;
    font-size: 18px;
    color: #333;

    b{
      font-size: 14px;
      vertical-align: 2px;
      color: #fb6464;
    }
    span{
      color: #999;
      font-weight: 500;
      font-size: 14px;
      display: block;
      margin: 3px 0;
    }
  }
  div{
    text-align: left;
  }
}
.lyft-error{
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// CancelReservation.vue?a325b62c